import { render, staticRenderFns } from "./ReferenceDocuments.vue?vue&type=template&id=0f2d7252"
import script from "./ReferenceDocuments.vue?vue&type=script&lang=js"
export * from "./ReferenceDocuments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports